import { SolarPanelIcon } from './SolarPanelIcon';

/**
 * author: Kristian Mohl
 * id 46CD8278-94CE-46F4-B2A5-01D4595E48A0
 * name solar-panel
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/solar-panel.svg
 * tags
 * - Home Automation 
 */
export const SolarElectricityIcon = SolarPanelIcon;
export default SolarElectricityIcon